module.exports = __webpack_public_path__ + "static/media/b2b-1.08f42180.jpg";